import { MouseEvent } from 'react';
import styled from 'styled-components';

import { useCurrentUserContext } from 'contexts/currentUser';
import { useRestrictedAccessContext } from 'contexts/restrictedAccess';

const Wrapper = styled.div`
  display: inline-flex;
  width: max-content;
  & > * {
    flex: 1;
  }
  &:empty {
    display: none;
  }
`;

type Props = {
  hasBlockchainRewards: boolean;
  children: ({
    disabledClaim,
  }: {
    disabledClaim: boolean;
  }) => React.JSX.Element;
};

export const ShouldVerifyUserBeforeClaiming = ({
  hasBlockchainRewards,
  children,
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const { setShowRestrictedAccess } = useRestrictedAccessContext();
  const shouldVerifyPhone =
    hasBlockchainRewards && !currentUser?.phoneNumberVerified;
  const shouldVerifyEmail = !currentUser?.confirmed;

  const onClick = (e: MouseEvent<HTMLElement>) => {
    if (shouldVerifyEmail) {
      setShowRestrictedAccess('email');
      e.stopPropagation();
      e.preventDefault();
    } else if (shouldVerifyPhone) {
      setShowRestrictedAccess('phone');
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <Wrapper onClickCapture={onClick}>
      {children({ disabledClaim: shouldVerifyPhone })}
    </Wrapper>
  );
};
